import React, { useEffect, useState } from 'react';
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Tab,
  Table,
  Tabs,
} from 'react-bootstrap';
import Select from 'react-select';
import { FaDownload, FaPaperclip, FaPlus, FaSync, FaTrash, FaUpload } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { extrairMensagemErro } from '~/Utils/Helpers';
import * as api from '~/Services/Service';
import {
  arquivoPermitido,
  buscarOpcaoPorValor,
  calcularTempoDuracao,
  formatarData,
  formatarDataHora,
  montarOpcoesUsuarios,
  obterVariantPrioridade,
  obterVariantStatus,
  statusSolicitacao,
} from './helpers';

const STATUS_AGUARDANDO_ATENDIMENTO_INTERNO = 2;

const statusFormInicial = {
  status: '',
  usu_responsavel: null,
  previsao: '',
  observacao: '',
};

const ocorrenciaInicial = {
  titulo: '',
  texto: '',
};

const modalDetalheStyles = {
  modalBody: {
    backgroundColor: '#ffffff',
    padding: '12px 18px 18px',
  },
  tabsWrapper: {
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 0,
    padding: 0,
    boxShadow: 'none',
  },
  sectionCard: {
    border: '1px solid #dde5ef',
    borderRadius: '12px',
    boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
    marginBottom: '14px',
  },
  sectionHeader: {
    background: 'linear-gradient(90deg, #f8fafc 0%, #eef4fb 100%)',
    borderBottom: '1px solid #dde5ef',
    padding: '10px 14px',
  },
  sectionTitle: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 700,
    color: '#24324a',
  },
  sectionBody: {
    padding: '14px',
  },
  infoItem: {
    border: '1px solid #e5eaf1',
    borderRadius: '10px',
    padding: '10px 12px',
    height: '100%',
    backgroundColor: '#ffffff',
  },
  infoLabel: {
    color: '#6b7280',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    marginBottom: '4px',
  },
  infoValue: {
    color: '#1f2937',
    fontSize: '13px',
    lineHeight: '1.35',
  },
  observacaoBox: {
    border: '1px solid #dde5ef',
    borderRadius: '10px',
    backgroundColor: '#fbfdff',
    minHeight: '78px',
    padding: '10px 12px',
    color: '#334155',
    lineHeight: '1.45',
    whiteSpace: 'pre-wrap',
  },
  urgenciaBox: {
    border: '1px solid #fde68a',
    backgroundColor: '#fffbeb',
    borderRadius: '10px',
    padding: '10px 12px',
    marginTop: '8px',
  },
  tempoItem: {
    border: '1px solid #dbe4ef',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    padding: '12px',
    minHeight: '78px',
  },
  timelineItem: {
    position: 'relative',
    paddingLeft: '22px',
    marginBottom: '12px',
  },
  timelineMarker: {
    position: 'absolute',
    left: 0,
    top: '4px',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#0d6efd',
    boxShadow: '0 0 0 4px rgba(13, 110, 253, 0.12)',
  },
  timelineContent: {
    border: '1px solid #e3e8f0',
    borderRadius: '10px',
    backgroundColor: '#ffffff',
    padding: '10px 12px',
  },
  emptyState: {
    border: '1px dashed #cbd5e1',
    borderRadius: '10px',
    padding: '18px',
    textAlign: 'center',
    color: '#64748b',
    backgroundColor: '#f8fafc',
  },
  campoTexto: {
    borderRadius: '6px',
    width: '100%',
    minHeight: '38px',
    height: '38px',
    fontFamily: "'Open Sans', Arial, sans-serif",
    boxSizing: 'border-box',
    border: '1px solid #ced4da',
    backgroundColor: '#fff',
    padding: '0.375rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.5',
  },
  campoTextarea: {
    borderRadius: '6px',
    width: '100%',
    minHeight: '86px',
    fontFamily: "'Open Sans', Arial, sans-serif",
    boxSizing: 'border-box',
    border: '1px solid #ced4da',
    backgroundColor: '#fff',
    padding: '0.375rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: '1.5',
  },
  arquivoBox: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    border: '1px dashed #b8c7d9',
    borderRadius: '10px',
    backgroundColor: '#fbfdff',
    padding: '10px',
  },
  arquivoBotao: {
    display: 'inline-flex',
    alignItems: 'center',
    border: '1px solid #0d6efd',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    color: '#0d6efd',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 600,
    padding: '7px 12px',
    margin: '0 10px 0 0',
  },
  arquivoNome: {
    color: '#64748b',
    fontSize: '13px',
    lineHeight: '1.35',
  },
};

const valorOuPadrao = valor => {
  if (valor === null || valor === undefined || valor === '') {
    return 'Não informado';
  }

  return valor;
};

const InfoItem = ({ label, children }) => {
  const valor =
    children !== null && children !== undefined && children !== ''
      ? children
      : 'Não informado';

  return (
    <div style={modalDetalheStyles.infoItem}>
      <div style={modalDetalheStyles.infoLabel}>{label}</div>
      <div style={modalDetalheStyles.infoValue}>{valor}</div>
    </div>
  );
};

const TempoItem = ({ label, valor }) => (
  <div style={modalDetalheStyles.tempoItem}>
    <div style={modalDetalheStyles.infoLabel}>{label}</div>
    <div style={modalDetalheStyles.infoValue}>{valorOuPadrao(valor)}</div>
  </div>
);

const SecaoCard = ({ titulo, children, actions }) => (
  <Card style={modalDetalheStyles.sectionCard}>
    <Card.Header style={modalDetalheStyles.sectionHeader}>
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <h6 style={modalDetalheStyles.sectionTitle}>{titulo}</h6>
        {actions && <div>{actions}</div>}
      </div>
    </Card.Header>
    <Card.Body style={modalDetalheStyles.sectionBody}>{children}</Card.Body>
  </Card>
);

const dataParaInput = valor => {
  if (!valor) return '';
  return String(valor).substring(0, 10);
};

const ModalDetalheSolicitacao = ({
  show,
  codigo,
  onHide,
  onAtualizado,
}) => {
  const [abaAtiva, setAbaAtiva] = useState('detalhes');
  const [detalhe, setDetalhe] = useState(null);
  const [historico, setHistorico] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [statusForm, setStatusForm] = useState(statusFormInicial);
  const [ocorrencia, setOcorrencia] = useState(ocorrenciaInicial);
  const [arquivo, setArquivo] = useState(null);
  const [usuariosResponsaveis, setUsuariosResponsaveis] = useState([]);

  const opcoesUsuarios = montarOpcoesUsuarios(usuariosResponsaveis);
  const anexos = detalhe && detalhe.anexos ? detalhe.anexos : [];
  const statusExigeResponsavel =
    Number(statusForm.status) === STATUS_AGUARDANDO_ATENDIMENTO_INTERNO;

  const carregarUsuariosResponsaveis = async departamento => {
    if (!departamento) {
      setUsuariosResponsaveis([]);
      return;
    }

    try {
      const resposta = await api.listarResponsaveisSolicitacaoJuridica(
        departamento
      );
      setUsuariosResponsaveis(resposta || []);
    } catch (err) {
      setUsuariosResponsaveis([]);
      toast.error(
        extrairMensagemErro(err) || 'Erro ao carregar responsáveis do departamento.'
      );
    }
  };

  const carregarDetalhe = async () => {
    if (!codigo) return;
    setCarregando(true);
    setErro('');
    try {
      const resposta = await api.buscarSolicitacaoJuridica(codigo);
      const dados = resposta || {};
      setDetalhe(dados);
      setHistorico(dados.historico || []);
      setStatusForm({
        status:
          dados.status !== null && dados.status !== undefined
            ? dados.status
            : '',
        usu_responsavel: dados.usu_responsavel || null,
        previsao: dataParaInput(dados.previsao),
        observacao: '',
      });
      if (dados.status === STATUS_AGUARDANDO_ATENDIMENTO_INTERNO) {
        await carregarUsuariosResponsaveis(dados.departamento);
      } else {
        setUsuariosResponsaveis([]);
      }
    } catch (err) {
      setErro(extrairMensagemErro(err) || 'Erro ao carregar solicitação.');
      setDetalhe(null);
      setHistorico([]);
      setUsuariosResponsaveis([]);
    } finally {
      setCarregando(false);
    }
  };

  const carregarHistorico = async () => {
    if (!codigo) return;
    try {
      const resposta = await api.listarHistoricoSolicitacaoJuridica(codigo);
      setHistorico(resposta || []);
    } catch (err) {
      toast.error(extrairMensagemErro(err) || 'Erro ao carregar histórico.');
    }
  };

  useEffect(() => {
    if (show && codigo) {
      setAbaAtiva('detalhes');
      setOcorrencia(ocorrenciaInicial);
      setArquivo(null);
      setUsuariosResponsaveis([]);
      carregarDetalhe();
    }
  }, [show, codigo]);

  const alterarStatusForm = (campo, valor) => {
    if (campo === 'status') {
      const status = valor === '' || valor === null ? '' : Number(valor);

      if (status === STATUS_AGUARDANDO_ATENDIMENTO_INTERNO) {
        if (detalhe && detalhe.departamento) {
          carregarUsuariosResponsaveis(detalhe.departamento);
        }

        setStatusForm(prev => ({
          ...prev,
          status,
        }));
        return;
      }

      setUsuariosResponsaveis([]);
      setStatusForm(prev => ({
        ...prev,
        status,
        usu_responsavel: null,
        previsao: '',
      }));
      return;
    }

    setStatusForm(prev => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const salvarStatus = async () => {
    if (statusForm.status === '' || statusForm.status === null) {
      toast.error('Informe o status.');
      return;
    }

    if (statusExigeResponsavel && !statusForm.usu_responsavel) {
      toast.error('Informe o responsável pelo atendimento.');
      return;
    }

    const status = Number(statusForm.status);
    const payload = {
      status,
      usu_responsavel: null,
      previsao: null,
      observacao: statusForm.observacao,
    };

    if (status === STATUS_AGUARDANDO_ATENDIMENTO_INTERNO) {
      payload.usu_responsavel = statusForm.usu_responsavel;
      payload.previsao = statusForm.previsao
        ? statusForm.previsao + 'T00:00:00'
        : null;
    }

    setSalvando(true);
    try {
      await api.alterarStatusSolicitacaoJuridica(codigo, payload);
      toast.success('Status alterado com sucesso.');
      await carregarDetalhe();
      if (onAtualizado) onAtualizado();
    } catch (err) {
      toast.error(extrairMensagemErro(err) || 'Erro ao alterar status.');
    } finally {
      setSalvando(false);
    }
  };

  const alterarOcorrencia = (campo, event) => {
    const valor = event && event.target ? event.target.value : '';

    setOcorrencia(prev => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const salvarOcorrencia = async () => {
    if (!ocorrencia.titulo || !ocorrencia.texto) {
      toast.error('Informe título e texto da mensagem.');
      return;
    }

    setSalvando(true);
    try {
      await api.criarOcorrenciaSolicitacaoJuridica(codigo, ocorrencia);
      toast.success('Mensagem registrada com sucesso.');
      setOcorrencia(ocorrenciaInicial);
      await carregarHistorico();
      if (onAtualizado) onAtualizado();
    } catch (err) {
      toast.error(extrairMensagemErro(err) || 'Erro ao registrar mensagem.');
    } finally {
      setSalvando(false);
    }
  };

  const alterarArquivo = event => {
    const selecionado =
      event.target.files && event.target.files.length > 0
        ? event.target.files[0]
        : null;

    if (selecionado && !arquivoPermitido(selecionado)) {
      setArquivo(null);
      toast.error('Anexo inválido. Use PDF, JPG, PNG, DOCX, XLSX ou CSV.');
      return;
    }

    setArquivo(selecionado);
  };

  const enviarAnexo = async () => {
    if (!arquivo) {
      toast.error('Selecione um arquivo.');
      return;
    }

    const formData = new FormData();
    formData.append('file', arquivo);
    setSalvando(true);
    try {
      await api.uploadAnexoSolicitacaoJuridica(codigo, formData);
      toast.success('Anexo enviado com sucesso.');
      setArquivo(null);
      await carregarDetalhe();
      if (onAtualizado) onAtualizado();
    } catch (err) {
      toast.error(extrairMensagemErro(err) || 'Erro ao enviar anexo.');
    } finally {
      setSalvando(false);
    }
  };

  const baixarAnexo = async anexo => {
    try {
      const resposta = await api.downloadAnexoSolicitacaoJuridica(
        anexo.codigo,
        anexo.seq
      );
      const blob = resposta instanceof Blob ? resposta : new Blob([resposta]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = anexo.nome_arquivo || `anexo-${anexo.seq}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(extrairMensagemErro(err) || 'Erro ao baixar anexo.');
    }
  };

  const removerAnexo = async anexo => {
    if (!anexo || anexo.seq === null || anexo.seq === undefined) {
      toast.error('Anexo inválido.');
      return;
    }

    const nomeArquivo = anexo.nome_arquivo || 'este anexo';
    const confirmar = window.confirm(
      'Deseja remover o anexo "' + nomeArquivo + '"?'
    );

    if (!confirmar) return;

    setSalvando(true);
    try {
      await api.removerAnexoSolicitacaoJuridica(codigo, anexo.seq);
      toast.success('Anexo removido com sucesso.');
      await carregarDetalhe();
      if (onAtualizado) onAtualizado();
    } catch (err) {
      toast.error(extrairMensagemErro(err) || 'Erro ao remover anexo.');
    } finally {
      setSalvando(false);
    }
  };

  const renderDetalhes = () => {
    if (!detalhe) return null;

    return (
      <>
        <SecaoCard titulo="Resumo da solicitacao">
          <Row>
            <Col md={3} className="mb-3">
              <InfoItem label="Protocolo">{detalhe.codigo}</InfoItem>
            </Col>
            <Col md={3} className="mb-3">
              <InfoItem label="Data">
                {formatarDataHora(detalhe.data_solicitacao)}
              </InfoItem>
            </Col>
            <Col md={3} className="mb-3">
              <InfoItem label="Status">
                <Badge variant={obterVariantStatus(detalhe.status)}>
                  {detalhe.status_descricao}
                </Badge>
              </InfoItem>
            </Col>
            <Col md={3} className="mb-3">
              <InfoItem label="Prioridade">
                <Badge variant={obterVariantPrioridade(detalhe.prioridade)}>
                  {detalhe.prioridade_descricao}
                </Badge>
              </InfoItem>
            </Col>
            <Col md={4} className="mb-3">
              <InfoItem label="Departamento">
                {detalhe.departamento_descricao}
              </InfoItem>
            </Col>
            <Col md={4} className="mb-3">
              <InfoItem label="Responsável">{detalhe.responsavel_nome}</InfoItem>
            </Col>
            <Col md={4} className="mb-3">
              <InfoItem label="Cliente">{detalhe.cliente_nome}</InfoItem>
            </Col>
            <Col md={12}>
              <InfoItem label="Empreendimento">
                {detalhe.empreendimento_nome}
              </InfoItem>
            </Col>
          </Row>
        </SecaoCard>

        <SecaoCard titulo="Observação">
          <div style={modalDetalheStyles.observacaoBox}>
            {detalhe.obs || 'Sem observação.'}
          </div>
        </SecaoCard>

        <SecaoCard titulo="Atualizar atendimento">
          <Row>
            <Col md={4} className="mb-3">
              <Form.Label className="small mb-1">Status</Form.Label>
              <Select
                options={statusSolicitacao}
                value={buscarOpcaoPorValor(statusSolicitacao, statusForm.status)}
                onChange={opcao =>
                  alterarStatusForm('status', opcao ? opcao.value : '')
                }
                components={{ DropdownIndicator }}
                styles={customStyles}
              />
            </Col>
            {statusExigeResponsavel && (
              <>
                <Col md={4} className="mb-3">
                  <Form.Label className="small mb-1">Responsável</Form.Label>
                  <Select
                    isClearable
                    options={opcoesUsuarios}
                    value={buscarOpcaoPorValor(
                      opcoesUsuarios,
                      statusForm.usu_responsavel
                    )}
                    onChange={opcao =>
                      alterarStatusForm(
                        'usu_responsavel',
                        opcao ? opcao.value : null
                      )
                    }
                    components={{ DropdownIndicator }}
                    styles={customStyles}
                    noOptionsMessage={() => 'Nenhum usuário encontrado'}
                  />
                </Col>
                <Col md={4} className="mb-3">
                  <Form.Label className="small mb-1">Previsão</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    value={statusForm.previsao}
                    style={modalDetalheStyles.campoTexto}
                    onChange={event =>
                      alterarStatusForm('previsao', event.target.value)
                    }
                  />
                </Col>
              </>
            )}
          </Row>
          <Form.Group>
            <Form.Label className="small mb-1">Observação da ação</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={statusForm.observacao}
              style={modalDetalheStyles.campoTextarea}
              onChange={event =>
                alterarStatusForm('observacao', event.target.value)
              }
            />
          </Form.Group>
          <div className="text-right mt-3">
            <Button
              size="sm"
              variant="primary"
              disabled={salvando}
              onClick={salvarStatus}
            >
              Salvar status
            </Button>
          </div>
        </SecaoCard>
      </>
    );
  };

  const renderMensagens = () => (
    <>
      <SecaoCard titulo="Registrar mensagem">
        <Row>
          <Col md={4}>
            <Form.Group>
            <Form.Label className="small mb-1">Título</Form.Label>
              <Form.Control
                size="sm"
                value={ocorrencia.titulo}
                style={modalDetalheStyles.campoTexto}
                onChange={event => alterarOcorrencia('titulo', event)}
              />
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group>
              <Form.Label className="small mb-1">Mensagem</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={ocorrencia.texto}
                style={modalDetalheStyles.campoTextarea}
                onChange={event => alterarOcorrencia('texto', event)}
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="text-right">
          <Button
            size="sm"
            variant="primary"
            disabled={salvando}
            onClick={salvarOcorrencia}
          >
            <FaPlus className="mr-1" /> Registrar mensagem
          </Button>
        </div>
      </SecaoCard>
      {renderHistoricoLista('Mensagens registradas')}
    </>
  );

  const renderDocumentos = () => (
    <>
      <SecaoCard titulo="Enviar anexo">
        <Row className="align-items-end">
          <Col md={8}>
            <Form.Label className="small mb-1">Novo anexo</Form.Label>
            <div style={modalDetalheStyles.arquivoBox}>
              <input
                id="arquivo-detalhe-solicitacao-juridica"
                type="file"
                accept=".pdf,.jpg,.png,.docx,.xlsx,.csv"
                style={{ display: 'none' }}
                onChange={alterarArquivo}
              />
              <label
                htmlFor="arquivo-detalhe-solicitacao-juridica"
                style={modalDetalheStyles.arquivoBotao}
              >
                <FaPaperclip className="mr-1" /> Selecionar arquivo
              </label>
              <span style={modalDetalheStyles.arquivoNome}>
                {arquivo && arquivo.name ? arquivo.name : 'Nenhum arquivo selecionado'}
              </span>
            </div>
          </Col>
          <Col md={4} className="text-md-right mt-2 mt-md-0">
            <Button
              size="sm"
              variant="primary"
              disabled={!arquivo || salvando}
              onClick={enviarAnexo}
            >
              <FaUpload className="mr-1" /> Enviar
            </Button>
          </Col>
        </Row>
      </SecaoCard>

          <SecaoCard titulo="Anexos da solicitação">
        <Table
          bordered
          hover
          size="sm"
          className="mb-0"
          style={{ tableLayout: 'fixed' }}
        >
          <thead>
            <tr>
              <th style={{ width: 70 }}>Seq.</th>
              <th>Arquivo</th>
              <th style={{ width: '24%' }}>Usuario</th>
              <th style={{ width: 150 }}>Data</th>
              <th className="text-center" style={{ width: 120 }}>
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            {anexos.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  Nenhum anexo encontrado.
                </td>
              </tr>
            )}
            {anexos.map(anexo => (
              <tr key={`${anexo.codigo}-${anexo.seq}`}>
                <td>{anexo.seq}</td>
                <td>{anexo.nome_arquivo}</td>
                <td>{anexo.usuario_nome}</td>
                <td>{formatarDataHora(anexo.data)}</td>
                <td className="text-center">
                  <Button
                    size="sm"
                    variant="link"
                    title="Baixar anexo"
                    onClick={() => baixarAnexo(anexo)}
                  >
                    <FaDownload />
                  </Button>
                  <Button
                    size="sm"
                    variant="link"
                    className="text-danger"
                    title="Remover anexo"
                    disabled={salvando}
                    onClick={() => removerAnexo(anexo)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </SecaoCard>
    </>
  );

  const renderTempoDuracao = () => {
    if (!detalhe) return null;
    return (
      <SecaoCard titulo="Tempo de duração">
        <Row>
          <Col md={4} className="mb-3">
            <TempoItem
              label="Solicitação"
              valor={formatarDataHora(detalhe.data_solicitacao)}
            />
          </Col>
          <Col md={4} className="mb-3">
            <TempoItem
              label="Atribuição"
              valor={formatarDataHora(detalhe.data_atribuicao)}
            />
          </Col>
          <Col md={4} className="mb-3">
            <TempoItem label="Previsão" valor={formatarData(detalhe.previsao)} />
          </Col>
          <Col md={4} className="mb-3 mb-md-0">
            <TempoItem
              label="Conclusão"
              valor={formatarDataHora(detalhe.data_conclusao)}
            />
          </Col>
          <Col md={4} className="mb-3 mb-md-0">
            <TempoItem
              label="Finalização"
              valor={formatarDataHora(detalhe.data_finalizado)}
            />
          </Col>
          <Col md={4}>
            <TempoItem label="Duração" valor={calcularTempoDuracao(detalhe)} />
          </Col>
        </Row>
      </SecaoCard>
    );
  };

  const renderHistoricoLista = titulo => (
    <SecaoCard
      titulo={titulo || 'Histórico'}
      actions={
        <Button size="sm" variant="outline-secondary" onClick={carregarHistorico}>
          <FaSync className="mr-1" /> Atualizar
        </Button>
      }
    >
      {historico.length === 0 && (
        <div style={modalDetalheStyles.emptyState}>
          Nenhum histórico encontrado.
        </div>
      )}
      {historico.map((item, indice) => (
        <div
          key={`${item.codigo}-${item.data}-${indice}`}
          style={modalDetalheStyles.timelineItem}
        >
          <span style={modalDetalheStyles.timelineMarker} />
          <div style={modalDetalheStyles.timelineContent}>
            <div className="d-flex justify-content-between flex-wrap">
              <strong>{item.titulo}</strong>
              <span className="text-muted small">
                {formatarDataHora(item.data)}
              </span>
            </div>
            <div className="small text-muted mb-1">{item.usuario_nome}</div>
            <div style={{ lineHeight: '1.45' }}>{item.texto}</div>
          </div>
        </div>
      ))}
    </SecaoCard>
  );

  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          Solicitação {codigo ? `#${codigo}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={modalDetalheStyles.modalBody}>
        {erro && <Alert variant="danger">{erro}</Alert>}
        {carregando && <Loading />}
        {!carregando && detalhe && (
          <div style={modalDetalheStyles.tabsWrapper}>
            <Tabs activeKey={abaAtiva} onSelect={setAbaAtiva}>
              <Tab eventKey="detalhes" title="Detalhes">
                <div className="pt-3">{renderDetalhes()}</div>
              </Tab>
              <Tab eventKey="mensagens" title="Mensagens">
                <div className="pt-3">{renderMensagens()}</div>
              </Tab>
              <Tab eventKey="documentos" title="Documentos">
                <div className="pt-3">{renderDocumentos()}</div>
              </Tab>
              <Tab eventKey="tempo" title="Tempo de Duração">
                <div className="pt-3">{renderTempoDuracao()}</div>
              </Tab>
              <Tab eventKey="historico" title="Histórico">
                <div className="pt-3">{renderHistoricoLista()}</div>
              </Tab>
            </Tabs>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalDetalheSolicitacao;
